define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var I18n = require('i18n!nls/main');
    var Config = require('config/application');

    return Backbone.Model.extend({
        parse: function (response) {
            if (typeof response.result != 'undefined') {
                return response.result.data;
            } else {
                return response;
            }
        },

        /**
         * Метод сохранения/обновления модели на сервере
         * @param  {Backbone.Collection} collection - коллекция в которую будет добавлена модель
         * @param  {Object} messages   - объект для вывода сообщений, содержит success и error сообщения
         * @param  {Object} showMessages   - показывать ли сообщения
         * @param {Function} callback Обратный вызов при успешном сохранении
         */
        save: function (collection, messages, showMessages, callback) {
            var self = this;
            var method = 'create';
            if (!this.isNew()) {
                if (this.updateMethod) {
                    method = this.updateMethod;
                } else {
                    method = 'update';
                }
            }
            callback = callback || function(){};

            messages = messages || undefined;

            if (typeof showMessages === 'undefined') showMessages = true;
            if (app.Temp.tasksSuccessMessage) app.Temp.tasksSuccessMessage.hide();

            if (typeof collection !== 'undefined') {
                if (typeof collection.silent !== 'undefined') {
                    collection = undefined;
                }
            }

            return this.sync(method, this, {
                success: function (response, textStatus, xhr) {
                    if (response.status == Config.STATUS_OK) {
                        if (typeof response.result !== 'undefined') {
                            app.Vents.trigger('model:saved', response.result.data, self);
                        }

                        if (typeof collection != 'undefined') {
                            if (typeof response.result != 'undefined') {
                                collection.add(response.result.data);
                                if (method === 'create') {
                                    app.Vents.trigger('notepad:modelAdded', response.result.data);
                                    app.Vents.trigger('tasks:modelAdded', response.result.data);
                                }
                            }
                        }

                        if (showMessages) {
                            if (typeof response.message !== 'undefined') {
                                app.Temp.tasksSuccessMessage = app.message.success(response.message);
                            } else {
                                if (typeof messages !== 'undefined') {
                                    app.Temp.tasksSuccessMessage = app.message.success(messages.success);
                                } else {
                                    app.Temp.tasksSuccessMessage = app.message.success(I18n.Saved);
                                }
                            }
                        }

                        if(typeof response.result !== 'undefined'){
                            if(typeof response.result.data !== 'undefined'){
                                callback(self, response.result.data);
                            }
                        }

                    } else if (xhr.status >= 200 && xhr.status < 300) {
                        if (typeof collection != 'undefined') {
                            collection.add(response);
                            if (method === 'create') {
                                app.Vents.trigger('notepad:modelAdded', response);
                                app.Vents.trigger('tasks:modelAdded', response);
                            }
                        }
                        
                        if (showMessages) {
                            if (typeof messages !== 'undefined') {
                                app.Temp.tasksSuccessMessage = app.message.success(messages.success);
                            } else {
                                app.Temp.tasksSuccessMessage = app.message.success(I18n.Saved);
                            }
                        }

                        callback(self, response);
                    } else {
                        if (showMessages) {
                            if (typeof response.message != 'undefined') {
                                app.Temp.tasksSuccessMessage = app.message.success(response.message);
                            } else {
                                if (typeof messages != 'undefined') {
                                    app.Temp.tasksSuccessMessage = app.message.success(messages.error);
                                } else {
                                    app.message.error(I18n.Error);
                                }
                            }
                        }
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    // сервер недоступен попробуйте позже
                    if (Config.DEBUG && showMessages) {
                        if(typeof xhr.responseJSON.message !== 'undefined') {
                            app.message.error(xhr.responseJSON.message);
                        } else {
                            app.message.error(textStatus + ' ' + errorThrown);
                        }

                    }
                }
            });
        },

        /**
         * Метод удаления модели на сервере
         * @param  {Object} messages   - объект для вывода сообщений, содержит success и error сообщения
         */
        destroy: function (messages, callback, silent) {
            var that = this;
            var request = false;
            var handlers = {
                success: function (response, textStatus, xhr) {
                    if (response === null || response.status == Config.STATUS_OK || xhr.status == 200) {
                        app.Vents.trigger('model:destroyed');
                        if (typeof that.collection != 'undefined') {
                            that.collection.remove(that);
                        }

                        if (response && typeof response.message !== 'undefined' && !silent) {
                            app.message.success(response.message);
                        } else {
                            if (typeof messages !== 'undefined' && !silent) {
                                app.message.success(messages.success);
                            }
                        }

                        callback();
                    } else {
                        if (typeof response.message !== 'undefined' && !silent) {
                            app.message.success(response.message);
                        } else {
                            if (typeof messages !== 'undefined' && !silent) {
                                app.message.success(messages.error);
                            }
                        }
                    }
                },
                error: function (xhr, textStatus, errorThrown) {
                    var errorMessage = textStatus + ' ' + errorThrown,
                        responseObj = $.parseJSON(xhr.responseText);

                    if (xhr.responseText && responseObj.message) {
                        errorMessage = responseObj.message;
                    }
                    // сервер недоступен попробуйте позже
                    if (Config.DEBUG) app.message.error(errorMessage);
                }
            };

            callback = callback || function(){};

            if(this.isNew()) {
                handlers.success(null);
            } else {
                request = this.sync('delete', this, handlers);
            }
            return request;
        }

    });

});
